import { continents } from "@/utils/constants/continents";

export const createChallengeOptions = {
  onlyWins: [
    {
      text: "Record based",
      value: "Record",
      desc: "Based on a single best match.",
    },
    {
      text: "Accumulative",
      value: "Cumulative",
      desc: "Based on all matches played.",
    },
  ],
  teamSize: [
    { text: "All", value: "All" },
    { text: "Solo", value: "Solo" },
    { text: "Duo", value: "Duo" },
    { text: "Trio", value: "Trio" },
    { text: "Quad", value: "Quad" },
  ],
  type: [
    { text: "Private", value: "private" },
    { text: "Public", value: "public" },
  ],
  region: continents,
};
